import { connect } from 'react-redux';

const mapStateToProps = (store) => {
  const { trackerLocationsEvent } = store.TrackerData;
  return {
    tabEventContext: trackerLocationsEvent.tabEventContext,
  };
};
export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
